import axiosInstance from '../config/axios';

const userHistoryService = {
  /**
   * جلب سجلات تسجيل دخول المستخدمين
   * @param {Object} params معايير البحث والتصفية
   * @returns {Promise} وعد بالبيانات
   */
  fetchUserLoginHistory: async (params = {}) => {
    try {
      const response = await axiosInstance.get('/api/user-login-history', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching user login history:', error);
      throw error;
    }
  },
  
  /**
   * جلب جميع سجلات تسجيل دخول مستخدم محدد
   * @param {string} userId معرف المستخدم
   * @returns {Promise} وعد بالبيانات
   */
  fetchUserLoginHistoryById: async (userId) => {
    try {
      const response = await userHistoryService.searchUserLoginHistory({
        search: typeof userId === 'string' ? userId : String(userId),
        per_page: 500
      });

      if (response?.status === 'success') {
        const records = response.data || [];
        const sortedRecords = [...records].sort((a, b) => new Date(b.login_time) - new Date(a.login_time));
        return { status: 'success', data: sortedRecords };
      }

      return { status: 'success', data: [] };
    } catch (error) {
      console.error('Error fetching user login history by ID:', error);
      throw error;
    }
  },
  
  /**
   * بحث في سجلات تسجيل دخول المستخدمين (مبوب)
   * @param {Object} params معايير البحث (search, per_page)
   * @returns {Promise} وعد بالبيانات
   */
  searchUserLoginHistory: async (params = {}) => {
    try {
      const response = await axiosInstance.get('/api/user-login-history/search', { params });
      return response.data;
    } catch (error) {
      console.error('Error searching user login history:', error);
      throw error;
    }
  },

  /**
   * إحصائيات سجلات تسجيل الدخول
   * @returns {Promise} وعد بالإحصائيات
   */
  getLoginHistoryStats: async () => {
    try {
      const response = await axiosInstance.get('/api/user-login-history/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching login history stats:', error);
      throw error;
    }
  },

  /**
   * تفريغ جميع سجلات تسجيل دخول المستخدمين
   * @returns {Promise} وعد بنتيجة العملية
   */
  clearAllLoginHistory: async () => {
    try {
      const response = await axiosInstance.post('/api/user-login-history/clear');
      return response.data;
    } catch (error) {
      console.error('Error clearing user login history:', error);
      throw error;
    }
  }
};

export default userHistoryService;
